<template>
  <v-data-table
    :headers="headers"
    :items="adminPayoutPaid"
    sort-by="id"
    :loading="tableLoader"
    loading-text="Fetching Payout Requests..."
    no-data-text="There are no pending payout requests."
    class="mb-12 elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Completed Payout Requests</v-toolbar-title>
      </v-toolbar>
    </template>

    <template v-slot:item.timestampCreated="{ item }">
      {{ item.timestampCreated | timestampToDate }}
    </template>

    <template v-slot:item.timestampCompleted="{ item }">
      {{ item.timestampCompleted | timestampToDate }}
    </template>

    <template v-slot:item.user.emailAddress="{ item }">
      <router-link :to="`/user/${item.id}`">
        {{ item.user.emailAddress }}
      </router-link>
    </template>

    <template v-slot:item.amount="{ item }">
      {{ item.amount | numberToMoney }}
    </template>

  </v-data-table>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PendingPayoutList',

    computed: {
      ...mapGetters([
        'adminPayoutPaid'
      ])
    },

    data: () => ({
      tableLoader: true,
      recordPaymentDialog: false,

      search: '',

      // Mapping datatable.
      headers: [
        {
          text: 'Requested',
          value: 'timestampCreated',
          align: 'start'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Email',
          value: 'user.emailAddress',
          sortable: true
        },
        {
          text: 'Method',
          value: 'method',
          sortable: true
        },
        {
          text: 'Amount Withdrawn',
          value: 'amount',
          align: 'right'
        },
        {
          text: 'Fulfilled',
          value: 'timestampCompleted',
          align: 'right'
        },
      ]
    }),

    methods: {
      ...mapActions([
        'getPaidStatus'
      ]),
    },

    created() {
      this.getPaidStatus().then(() => {
        this.tableLoader = false
      })
    }
  }
</script>
